<template>
    <div class="card notes-card h-100 border-0 shadow-sm mb-4">
        <div class="card-header bg-white border-0 pt-3 pb-2 px-4">
            <h3 class="card-title text-uppercase font-weight-500 mb-0 d-flex align-items-center">
                <Icon icon-class="ui-message-chat-circle" size="2" class="mr-2" />
                {{ t('invoices-internal_notes') }}
            </h3>
        </div>

        <div class="card-body pt-0 px-4 pb-3 d-flex flex-column h-100-content">
            <KvTextarea
                v-model="internalNotes"
                :rows="6"
                :resize="true"
                :placeholder="t('invoices-internal_notes_placeholder')"
                variant="outlined"
                class="mb-2"
            />

            <p class="small text-muted mb-2">
                {{ t('invoices-internal_notes_hint') }}
            </p>

            <div class="text-right mt-auto">
                <kv-button
                    variant="filled"
                    :prepend-icon="saving ? 'ui-loading-01' : 'ui-save-01'"
                    :disabled="saving || internalNotes === notesBaseline"
                    @click="saveNotes"
                >
                    {{ t('invoices-save_notes') }}
                </kv-button>
            </div>
        </div>
    </div>
</template>

<script>
import keviApi from "../../keviApi";
import { extractApiError } from "../helpers";
import KvTextarea from "../../components/inputs/kv-textarea.vue";
import Icon from "../../components/icon/icon.vue";

export default {
    name: "invoice-internal-notes",
    components: { KvTextarea, Icon },
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            internalNotes: "",
            saving: false,
            notesBaseline: ""
        };
    },
    watch: {
        invoice: {
            immediate: true,
            handler(newVal) {
                if (!newVal) return;
                let notes = newVal.internal_notes || "";
                if (newVal.invoice_type === "one_time" && this.noteRepeatsChargeTitle(notes, newVal.title)) {
                    notes = "";
                }
                this.internalNotes = notes;
                this.notesBaseline = notes;
            }
        }
    },
    methods: {
        reset() {
            this.internalNotes = this.notesBaseline;
        },
        noteRepeatsChargeTitle(notes, title) {
            const note = String(notes || "").trim();
            const name = String(title || "").trim();
            if (!note || !name) return false;
            return name === note || name.startsWith(note);
        },
        async saveNotes() {
            if (this.internalNotes === this.notesBaseline) return;

            this.saving = true;
            try {
                const options = keviApi.getOptions(`invoices/${this.invoice.id}/fields`, 'PATCH', {
                    internal_notes: this.internalNotes
                });

                const response = await this.$http(options);

                if (response.status === 200) {
                    this.$store.dispatch('notification/success', this.t('invoices-notes_saved_success'));
                    this.$emit('updated', this.internalNotes);
                } else {
                    const msg = extractApiError(response, this.t('invoices-save_notes_error'));
                    this.$store.dispatch('notification/error', msg);
                }
            } catch (error) {
                const msg = extractApiError(error, this.t('invoices-save_notes_error'));
                this.$store.dispatch('notification/error', msg);
                console.error("Erro ao salvar notas:", error);
            } finally {
                this.saving = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.notes-card {
    border-radius: 16px;
    border: 1px solid #E5E7EB !important;
    overflow: hidden;

    .card-title {
        font-size: 14px;
        color: #111827;
        letter-spacing: 0.05em;
    }

    .h-100-content {
        flex: 1;
        display: flex;
        flex-direction: column;

        ::v-deep .kv-native-input {
            min-height: 130px;
        }
    }
}
</style>
